// src/data/commodityDefinitions.js

export const COMMODITY_GROUPS = {
  // Uses Tickers (Symbols) for matching as they are more reliable than names
  ENERGY: [
    "BZ=F",  // Brent Crude Oil
    "CL=F",  // Crude Oil WTI
    "NG=F",  // Natural Gas
    "RB=F",  // RBOB Gasoline
    "HO=F",  // Heating Oil
    "BZ",    // Alternative ticker
    "CL"     // Alternative ticker
  ],
  METALS: [
    "GC=F",  // Gold
    "SI=F",  // Silver
    "PL=F",  // Platinum
    "PA=F",  // Palladium
    "HG=F",  // Copper
    "ALI=F", // Aluminum
    "SIL=F"  // Micro Silver
  ],
  VEGETABLE: [
    "ZC=F",  // Corn
    "ZS=F",  // Soybean
    "ZM=F",  // Soybean Meal
    "ZL=F",  // Soybean Oil
    "ZW=F",  // Wheat
    "KC=F",  // Coffee (US)
    "KT=F",  // Coffee
    "SB=F",  // Sugar
    "CC=F",  // Cocoa
    "CT=F",  // Cotton
    "OJ=F",  // Orange Juice
    "ZR=F"   // Rough Rice
  ],
  ANIMAL: [
    // --- US Futures (Yahoo/Global) ---
    "LE=F",  // Live Cattle (Gado em Pé - EUA)
    "GF=F",  // Feeder Cattle (Gado de Engorda)
    "HE=F",  // Lean Hogs (Suínos)
    
    // --- B3 Futures (Brasil) ---
    "BGI",    // Boi Gordo (Ticker Base B3)
    "@BGI",   // Boi Gordo (Alternative format)
    "BGIV25", // Boi Gordo (Specific Contract - Example)
    "BGIK25", // Boi Gordo (May Contract)

  ],
  INDUSTRIAL: [
    // These might vary heavily depending on your data source. 
    // If using Yahoo Finance, industrial metals like Copper/Aluminum are often under Metals.
    // We'll map standard industrial metals here just in case.
    "HG=F",  // Copper
    "ALI=F", // Aluminum
    "TIO=F", // Iron Ore (rare on standard feeds, often requires specific source)
    "LIT",   // Lithium ETF (proxy)
    "URA"    // Uranium ETF (proxy)
  ]
};